import Openseadragon from 'openseadragon'

let dzViewer = Openseadragon({
    id: 'player',
    prefixUrl: '/icons/osd/',
    tileSources: {
      Image: {
        'Url': 'https://files.aaroncurt.is/dzi/postdoc2019poster_files/',
        'xmlns': 'http://schemas.microsoft.com/deepzoom/2008',
        'Format': 'jpeg',
        'Overlap': '1',
        'TileSize': '254',
        'Size': {
          'Height': 16000,
          'Width': 12000
        },
      },
    }
  }
)
